import { MediaContainerController } from '@sas-dvr/ltjs-bird';
import { merge, from, of } from 'rxjs';
import { BIRDModelControllerLoader } from './LoaderFactory';
import { loadPositionedModelOwnerController } from './loadPositionedModelOwner';
import { ContainerState } from '@sas-dvr/internal-va-react-core/store/birdElement/containerState';
import { BirdLayoutState } from '@sas-dvr/internal-va-react-core/store/birdLayout/BirdLayoutState';
import { map, mergeMap } from 'rxjs/operators';
import { getControllerByName } from '../util/controllerUtils';
import { EpicActions } from '../actions/epicActions';

export const loadMediaContainerController: BIRDModelControllerLoader = (
  controller,
  unload$,
  myActions$,
  state$,
  deps
) => {
  if (!(controller instanceof MediaContainerController)) {
    throw new Error('Expected the controller to be a MediaContainerController');
  }

  const selectController = getControllerByName(controller, state$.value.bird.name);

  const loadChildren$ = selectController
    ? merge(
        of(EpicActions.actions.loadBirdModel(selectController)),
        unload$.pipe(mergeMap(() => of(EpicActions.actions.unloadBirdModel(selectController))))
      )
    : loadPositionedModelOwnerController(controller, unload$, myActions$, state$, deps);

  const key = deps.getKey(controller);
  const loadContainerElement$ = from([
    BirdLayoutState.actions.set(key, deps.getLayoutData(controller, selectController)),
    ContainerState.actions.add(key, {}),
  ]);

  return merge(
    loadChildren$,
    loadContainerElement$,
    unload$.pipe(map(() => ContainerState.actions.delete(key)))
  );
};
